import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceZone } from "@app/models/rest/resource-zone";

@Injectable({
  providedIn: "root"
})
export class ResourceZoneRestService extends HateoasResourceOperation<ResourceZone> {
  constructor() {
    super(ResourceZone);
  }
}
